<script>
    import Alert from './componentes/Alert.svelte';
    import Helper from './components/Helper.svelte';
	import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';
	import Titlesection from './components/Titlesection.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
	import Navbar from './components/Navbar.svelte';
    import { push } from 'svelte-spa-router';
    import { urlapi, permisos, permisos_struct,permisos_title,miPermiso,iduser,login } from './stores/store';
    import { object2array, postData, isJson, mergeDeep, moneda, verifyAccess } from './scripts';
    import moment from 'moment'

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if( $miPermiso.tokenfel.access===false ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    // status
    let disabled=false;
    let guardando=false;
    let insertando=false;

    let helper=false;
    let historial=[];
    let errores=false;

    let llave=false;
    let creacion=false; //24 noviembre 2021 11:03:38
    let vencimiento=false; //22 febrero 2022 11:03:38
    let status=false //ACTIVO - Faltan 89 dias para su vencimiento;

    let solicitar_token=function() {
        guardando=true;
        disabled=true;
        postData($urlapi, [{ 'cmd':'fel_getNewToken' }])
        .then(data => {
            if(data[0].result===false)
            {
                errores=data[0].errores.errores;
            } else {
                errores=false;
                load();
            }
            
            guardando=false;
            disabled=false;
        });
    }
    let load=function() {
        postData($urlapi, [{ 'cmd':'fel_getTokens' }])
        .then(data => {
            if(data[0].result===false)
            {
                llave=false;
                creacion=false;
                vencimiento=false;
                status=false;
            } else {
                llave=data[0].result.token;
                creacion=data[0].result.creacion;
                vencimiento=data[0].result.vigencia;
                status=Boolean(data[0].result.activo);
                historial= object2array( data[0].noactivo );
            }
        });
    }

    let salir=function() {
        push('/config')
    }

    load();
</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer marginTop=0>
    <Titlesection>
        <span slot="title"><i class="bi bi-key me-1" />Token FEL</span>
        <span slot="toolbar">
            <span on:mouseenter={()=>helper='Solicitar Token FEL'} on:mouseleave={()=>helper=false}>
            <button {disabled} class="btn btn-success" on:click={solicitar_token}>

                {#if guardando===true}
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {/if}                
            <i class="bi bi-key me-1"></i><i class="bi bi-search"></i></button>
            </span>
            <span on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}>
                <button disabled={disabled} class="btn btn-warning btn-sm" on:click={salir}><i class="bi bi-box-arrow-in-left"></i></button>
            </span>
        </span>
    </Titlesection>
    
    <br/>
    {#if errores!==false}
        <Alert parpadea valign='middle' lheight='2'>
            <strong>Error generando Token:</strong> {errores}
        </Alert>
    {/if}

    
    <div class="row">
        <div class="col-12 col-md-6">

            <h6 class='fw-bold text-uppercase text-warning'>TOKEN</h6>
            <p class='lh-1 bg-light border p-2' style='overflow-wrap: break-word;word-wrap: break-word;'>
                <small>
                {#if llave===false}
                    <small class='text-danger'>NO DISPONIBLE</small>
                {:else}
                    {llave}
                {/if}
                </small>
            </p>
            <h6 class='fw-bold text-uppercase text-warning'>CREACIÓN</h6>
            <p class='lh-1 bg-light border p-2' style='overflow-wrap: break-word;word-wrap: break-word;'>
                    {#if creacion===false}
                        <span class='text-danger'>NO DISPONIBLE</span>
                    {:else}
                        {moment(creacion).format('DD/MM/YYYY, HH:mm:ss')}
                    {/if}
            </p>
            <h6 class='fw-bold text-uppercase text-warning'>VENCIMIENTO</h6>
            <p class='lh-1 bg-light border p-2' style='overflow-wrap: break-word;word-wrap: break-word;'>
                {#if vencimiento===false}
                    <span class='text-danger'>NO DISPONIBLE</span>
                {:else}
                    {moment(vencimiento).format('DD/MM/YYYY, HH:mm:ss')}
                {/if}                
            </p>
            <h6 class='fw-bold text-uppercase text-warning'>STATUS</h6>
            <p class='lh-1 bg-light border p-2' style='overflow-wrap: break-word;word-wrap: break-word;'>
                    {#if status===false}
                        <span class='text-danger'>NO DISPONIBLE</span>
                    {:else}
                        <span class='text-success'><i class="bi bi-check-all"></i> ACTIVO</span>
                        <small>- Faltan <strong>{moment(vencimiento).diff(moment(), 'days')}</strong> dias para su vencimiento</small>
                    {/if}
            </p>

        </div>
        <div class="col-12 col-md-6">
            <h6 class='fw-bold text-uppercase text-warning'>ÚLTIMOS 5 TOKENS INACTIVOS</h6>

            <div class="accordion accordion-flush border" id="accordionFlushExample">
                {#each historial as item, index (index)}
                
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading{index}">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse{index}" aria-expanded="false" aria-controls="flush-collapse{index}">
                            Creado el {moment(item.creacion).format('DD/MM/YYYY, HH:mm:ss')}
                        </button>
                        </h2>
                        <div id="flush-collapse{index}" class="accordion-collapse collapse" aria-labelledby="flush-heading{index}" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                    <h6 class='fw-bold text-uppercase text-warning' style='font-size:0.8em;'>TOKEN</h6>
                                    <p class='lh-1 bg-light border p-2' style='overflow-wrap: break-word;word-wrap: break-word;'>
                                        <small>
                                        {#if item.token===false}
                                            <small class='text-danger'>NO DISPONIBLE</small>
                                        {:else}
                                            {item.token}
                                        {/if}
                                        </small>
                                    </p>
                                    <h6 class='fw-bold text-uppercase text-warning' style='font-size:0.8em;'>VENCIMIENTO</h6>
                                    <p class='lh-1 bg-light border p-2' style='overflow-wrap: break-word;word-wrap: break-word;'>
                                        {#if item.vigencia===false}
                                            <span class='text-danger'>NO DISPONIBLE</span>
                                        {:else}
                                            {moment(item.vigencia).format('DD/MM/YYYY, HH:mm:ss')}
                                        {/if}                
                                    </p>
                                    <h6 class='fw-bold text-uppercase text-warning' style='font-size:0.8em;'>STATUS</h6>
                                    <span class='text-danger'><i class="bi bi-flag"></i> INACTIVO</span>
                            </div>
                        </div>
                    </div>
                {:else}
                    <p class='p-2 mb-0 text-danger'><i class="bi bi-exclamation-diamond me-1"></i>No hay historial de <strong>Tokens</strong></p>
                {/each}

            </div>
        </div>
    </div>
    <Helper bind:text={helper}></Helper>
</AnimationContainer>
{/if}

<style>
.accordion-button {
    background: var(--bs-primary) !important;
    
    color:#fff !important;
}

.accordion-button::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
}

.accordion-button.collapsed {
  background: var(--bs-light) !important;
  color:#333 !important;
}

.accordion-button.collapsed::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23333'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
}
</style>